module.exports = __webpack_public_path__ + "media/images/icon/icons8-Error-34ae7098d22744c5c27d806891de602f.png";